import { render, staticRenderFns } from "./RentSettlmentTab.vue?vue&type=template&id=68f475dc&scoped=true&"
import script from "./RentSettlmentTab.vue?vue&type=script&lang=js&"
export * from "./RentSettlmentTab.vue?vue&type=script&lang=js&"
import style0 from "./RentSettlmentTab.vue?vue&type=style&index=0&id=68f475dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f475dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VRow,VTextField})
